import { useState } from "react";
import toast from "react-hot-toast";
import { Header } from "../../components";
import KebabMenu from "../../components/KebabMenu";
import TablaCanonica from "../../components/TablaCanonica";

// Página de muestra de TablaCanonica (10.161) — SOLO para verificar visualmente el molde, no es
// una pantalla de negocio. Cubre los 8 casos pedidos: plata con positivos y negativos, totales,
// fila expandible, cargando, vacío, orden por columna, acciones con ⋮, densidad compacta.
// Ver ficha docs/componentes/tabla-canonica.md.

const MOVIMIENTOS = [
  { id: 1, fecha: "2026-09-02", concepto: "Sueldo Franco Díaz", categoria: "RRHH", monto: 1200000 },
  { id: 2, fecha: "2026-09-05", concepto: "Pago proveedor — Blackim", categoria: "Compras", monto: -450000 },
  { id: 3, fecha: "2026-09-10", concepto: "Comisión Nicolás Soto", categoria: "RRHH", monto: 85000 },
  { id: 4, fecha: "2026-09-14", concepto: "Devolución cliente", categoria: "Ventas", monto: -12000 },
  { id: 5, fecha: "2026-09-18", concepto: "Ajuste de redondeo", categoria: "Ajustes", monto: 0 },
  { id: 6, fecha: "2026-08-28", concepto: "Factura Google Ads", categoria: "Compras", monto: -318500 },
  { id: 7, fecha: "2026-09-22", concepto: "Anticipo factoring Xepelin", categoria: "Factoring", monto: 3250000 },
];

const columnasCompletas = [
  { key: "fecha", label: "Fecha", tipo: "fecha" },
  { key: "concepto", label: "Concepto", tipo: "texto", ancho: "32%" },
  { key: "categoria", label: "Categoría", tipo: "texto" },
  { key: "monto", label: "Monto", tipo: "plata" },
  {
    key: "acciones",
    label: "",
    tipo: "acciones",
    ordenable: false,
    ancho: "4%",
    render: (_valor, fila) => (
      <KebabMenu
        items={[
          { label: "Editar", onClick: () => toast.success(`Editar "${fila.concepto}" (demo, no hace nada real)`) },
          { label: "Eliminar", danger: true, onClick: () => toast.error(`Eliminar "${fila.concepto}" (demo)`) },
        ]}
      />
    ),
  },
];

const filasTotales = [
  {
    label: "Total",
    valores: { monto: MOVIMIENTOS.reduce((s, m) => s + m.monto, 0) },
  },
];

const detalleDeFila = (fila) => (
  <div style={{ fontSize: "0.8rem", color: "#475569" }}>
    <strong>Detalle de "{fila.concepto}"</strong> — categoría {fila.categoria}, id interno #{fila.id}. Contenido de
    ejemplo: acá vive cualquier desglose (líneas, documentos, sub-tabla) que la fila necesite mostrar al expandir.
  </div>
);

const TablaCanonicaDemo = () => {
  const [densidadCompacta, setDensidadCompacta] = useState(false);

  return (
    <div style={{ padding: 20 }}>
      <Header>
        <h5 style={{ margin: 0 }}>TablaCanonica — página de muestra</h5>
      </Header>

      <p style={{ color: "#64748b", fontSize: "0.85rem", maxWidth: 720 }}>
        Página interna, solo para verificar visualmente el molde (10.161) — no es una pantalla de negocio. Ver ficha{" "}
        <code>docs/componentes/tabla-canonica.md</code>.
      </p>

      <h6 className="mt-4">1. Completa — plata (+/−), totales, fila expandible, orden por columna, acciones</h6>
      <p style={{ color: "#94a3b8", fontSize: "0.78rem" }}>
        Clickeá el header "Fecha" o "Monto" para ordenar (asc → desc → natural). Clickeá la ▸ de una fila para ver su
        detalle. El monto en $0 (Ajuste de redondeo) queda sin color — el signo se lee por color, nunca por +/−.
      </p>
      <TablaCanonica
        columnas={columnasCompletas}
        filas={MOVIMIENTOS}
        filaExpandible={detalleDeFila}
        filasTotales={filasTotales}
      />

      <h6 className="mt-4">2. Cargando (10.273 — nunca se confunde con "vacío")</h6>
      <TablaCanonica columnas={columnasCompletas} filas={[]} cargando />

      <h6 className="mt-4">3. Vacío</h6>
      <TablaCanonica columnas={columnasCompletas} filas={[]} vacio="Sin movimientos en el período" />

      <h6 className="mt-4">4. Densidad compacta</h6>
      <div className="form-check mb-2">
        <input
          className="form-check-input"
          type="checkbox"
          id="densidad-compacta"
          checked={densidadCompacta}
          onChange={(e) => setDensidadCompacta(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="densidad-compacta" style={{ fontSize: "0.85rem" }}>
          Alternar densidad (compacta ⇄ normal) sobre la misma data
        </label>
      </div>
      <TablaCanonica
        columnas={columnasCompletas}
        filas={MOVIMIENTOS}
        densidad={densidadCompacta ? "compacta" : "normal"}
      />
    </div>
  );
};

export default TablaCanonicaDemo;
